define('viewmodels/pages/player/settings/settings',[
    'knockout',
    'underscore',
    'plugins/dialog'
], function (ko, _, dialog) {

    /* eslint-disable max-params */
    return function SettingsViewModel (
        player,
        SetSMSNewsletterSubscriptionCommand,
        SetNewsletterSubscriptionCommand,
        getField,
        ChangeEmailDialog,
        ChangePasswordDialog,
        ChangeMobileNumberDialog,
        ChangeRealityCheckDialog,
        changeRealityCheckIntervalModel,
        realityCheckContent,
        onCanReceivePluggableSettings
    ) {
        /* eslint-enable max-params */

        var self = this,
            setSMSNewsletterSubscriptionCommand = new SetSMSNewsletterSubscriptionCommand(
                {
                    on: ko.observable()
                }
            ),
            setNewsletterSubscriptionCommand = new SetNewsletterSubscriptionCommand(
                {
                    on: ko.observable()
                }
            );

        self.pluggableSettingsVMs = ko.observableArray();

        self.player = player.peek();
        self.contactInfo = self.player.contactInfo;
        self.configuration = self.player.configuration;

        // CMS content
        self.translations = {
            title: getField('title'),
            passwordLabel: getField('password_label'),
            emailLabel: getField('email_label'),
            mobileNumberLabel: getField('mobile_number_label'),
            offersByEmailLabel: getField('offers_by_email_label'),
            offersBySmsLabel: getField('offers_by_sms_label'),
            editButtonLabel: getField('edit_button'),
            verifyButtonLabel: getField('verify_button'),
            changeButtonLabel: getField('change_button'),
            realityCheckLabel: realityCheckContent.findFieldByName('reality_check_feature_title')
        };

        self.toggleNewsletterSubscription = function () {
            var subscribedToNewsletters = self.configuration.subscribedToNewsletters();

            setNewsletterSubscriptionCommand.on(subscribedToNewsletters);
            setNewsletterSubscriptionCommand.dispatch();
        };

        self.toggleSMSNewsletterSubscription = function () {
            var subscribedToSMSNewsletters = self.configuration.subscribedToSMSNewsletters();

            setSMSNewsletterSubscriptionCommand.on(subscribedToSMSNewsletters);
            setSMSNewsletterSubscriptionCommand.dispatch();
        };

        self.showChangeEmailDialog = function () {
            dialog.showDialog(new ChangeEmailDialog());
        };

        self.showChangePasswordDialog = function () {
            dialog.showDialog(new ChangePasswordDialog());
        };

        self.showChangeMobileNumberDialog = function () {
            dialog.showDialog(new ChangeMobileNumberDialog());
        };

        self.canChangeRealityCheckInterval = self.player.playOk.realityCheckIntervalUpdatable;

        self.realityCheckInterval = self.player.playOk.realityCheckInterval;

        self.realityCheckIntervalInMinutes = self.player.playOk.realityCheckIntervalMinutes;

        self.realityCheckIntervalForDisplay = realityCheckContent
            .findFieldByName('reality_check_interval_minutes')
            .replacements ({ intervalMinutes: self.realityCheckIntervalInMinutes });

        self.realityCheckEnabled = ko.pureComputed({
            read: function () {
                return !!self.realityCheckInterval();
            },
            write: function (enabled) {
                var disableRealityCheckCommand;

                if (enabled) {
                    self.showRealityCheckIntervalDialog();
                } else {
                    // send command to set time to 0
                    changeRealityCheckIntervalModel.realityCheckIntervalMinutes(0);
                    disableRealityCheckCommand = changeRealityCheckIntervalModel.createCommand();
                    disableRealityCheckCommand.dispatch();
                }
            }
        });

        self.showRealityCheckIntervalDialog = function () {
            return dialog.showDialog(new ChangeRealityCheckDialog(self.realityCheckIntervalInMinutes()));
        };

        self.attached = function () {
            // when we are attached publish a function so that other features can plugin settings
            // in the form of a viewmodel and view
            onCanReceivePluggableSettings(self.addPluggableSettingVM.bind(self));
        };

        self.addPluggableSettingVM = function (pluggableSettingVM) {
            self.pluggableSettingsVMs.push(pluggableSettingVM);
        };
    };
});


